const searchInput = document.querySelector('sticky-header .header__search input[type="search"]');
const searchInputContainer = document.querySelector('sticky-header .header__search .header__search-input');
const searchClear = document.querySelector('sticky-header .header__search .header__search-clear');

// Hide close button when clear button is clicked.
searchClear.addEventListener('click', () => {
  searchInputContainer.classList.remove('open');
});

// Show close button when search is focused.
searchInput.addEventListener('focusin', () => {
  searchInputContainer.classList.add('open');
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('predictive-search')) {
    const clearButton = document.querySelector('sticky-header .header__search button[type="reset"]');

    // Hide close button and clear search when close button is clicked;
    if (event.target.classList.contains('header__search-close') || event.target.closest('.header__search-close') && clearButton) {
      clearButton.click();
      searchInputContainer.classList.remove('open');
    };
  };
});
